class UserCardCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.user = options?.user ? {}
        @.link = options?.link ? false
        @.smokeFreeText = options?.smokeFreeText ? 'Rauchfrei seit dem'
        @.tag = options?.tag ? false
        @.text = options?.text ? false
        @.toProfileText = options?.toProfileText ? 'Zum Steckbrief'

        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement (@.tag ? 'div')
        @.$el.classList.add 'user-card'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.appendChild new ProfilePicCreate {
            attrs: {
                class: ['user-card__profile-pic']
            },
            badge: @.user.profilePic?.badge ? false,
            onWhite: true,
            pic: @.user.profilePic?.pic ? false
        }
        @.$el.innerHTML += "
            <div class='user-card__name'>#{ @.user.name ? 'n/a' }</div>
            #{ if @.user.smokeFree then "<div class='user-card__smoke-free'>#{ @.smokeFreeText }<span>#{ @.user.smokeFree }</span></div>" else "" }
            #{ if @.text then "<div class='user-card__text'>#{ @.text }</div>" else "" }
        "
        @.$el.appendChild new LinkButtonCreate {
            attrs: {
                class: ['user-card__link']
            },
            link: @.link,
            text: @.toProfileText
        }
        return

window.CreateUserCard= (options) ->
    return new UserCardCreate options